module.exports = __webpack_public_path__ + "img/export.346080e5.jpg";